"use client";
import Image from "next/image";
import React from "react";
import cx from "classnames";
import helper from "utils/helper";

interface ImageProps {
  wrapClassName?: string;
  className?: string;
  src: string;
  alt?: string;
  objectFit?: string;
  layout?: string;
  aspectRatio?: number;
  isRelative?: boolean;
  defaultImage?: React.ReactNode;
  // onLoad?: (e: unknown) => void;
  [key: string]: unknown;
}

export default function CustomImage({
  wrapClassName,
  className,
  src,
  alt = "lookme website",
  objectFit = "cover",
  layout = "fill",
  aspectRatio,
  isRelative = false,
  defaultImage,
  // onLoad,
  ...props
}: ImageProps) {
  const [imageSrc, $imageSrc] = React.useState(() => {
    return isRelative ? src : helper.imageUrl(src);
  });
  React.useEffect(() => {
    $imageSrc(isRelative ? src : helper.imageUrl(src));
  }, [src]); // eslint-disable-line react-hooks/exhaustive-deps
  console.log(imageSrc);
  return (
    <div className={cx("relative", wrapClassName)}>
      {!!imageSrc && (
        <Image
          className={cx("w-full h-full", className)}
          style={{
            aspectRatio,
            objectFit: objectFit as
              | "cover"
              | "contain"
              | "fill"
              | "none"
              | "scale-down",
          }}
          src={imageSrc}
          alt={alt || "lookme website"}
          priority
          fill={layout === "fill"}
          onLoad={() => {
            // console.log("Hình ảnh đã load thành công!");
          }}
          onError={() => {
            // console.log("Lỗi khi load hình ảnh!");

            $imageSrc("");
          }}
          onLoadingComplete={() => {
            // Callback này chạy khi hình ảnh load hoàn tất
            // console.log("Load hoàn tất:", result);
          }}
          {...props}
        />
      )}
      {!imageSrc && (
        <div
          className="w-full h-full rounded-md bg-gray-200 flex items-center justify-center"
          {...props}
        >
          {defaultImage}
        </div>
      )}
    </div>
  );
}
